// Countries with a predefined compliance document set — mirrors the backend
// registry at server/app/services/compliance/country_templates/__init__.py
// COUNTRY_TEMPLATES. Adding a country is two one-line registrations: the
// template module there, and an entry here so a SuperAdmin can tick it.
//
// A country present in one list and not the other is the failure worth knowing
// about: registered only on the backend it is seedable by API and invisible in
// the form, and registered only here it 422s on save. The backend test
// `tests/unit/test_country_templates.py` asserts the two lists agree, so a
// half-done addition fails there rather than in someone's browser.
//
// `value` is the ISO 3166-1 alpha-2 code the API stores and the seeder keys on.
// `label` is what the SuperAdmin sees. `description` names the regime the
// document set was drawn from, so the person ticking the box knows what the
// tenant is getting.
export const COUNTRY_MASTER_OPTIONS = [
  {
    value: "US",
    label: "United States",
    description: "Form I-9 work authorization, plus IRS and payroll records.",
  },
  {
    value: "GB",
    label: "United Kingdom",
    description: "Right-to-work checks, National Insurance, DBS and payroll.",
  },
  {
    value: "CA",
    label: "Canada",
    description: "IRPA work eligibility, Social Insurance Number and CRA forms.",
  },
  {
    value: "AU",
    label: "Australia",
    description: "Visa work rights, Tax File Number and Superannuation choice.",
  },
  {
    value: "PH",
    label: "Philippines",
    description: "SSS, PhilHealth, Pag-IBIG and BIR registration, plus NBI clearance.",
  },
  {
    value: "IN",
    label: "India",
    description: "Aadhaar and PAN, UAN provident fund, and prior-employment proofs.",
  },
];
